var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "section",
        {
          directives: [
            {
              name: "htmlclass",
              rawName: "v-htmlclass",
              value: _vm.customHtmlClasses,
              expression: "customHtmlClasses",
            },
          ],
          staticClass: "dialog",
        },
        [
          _c("div", { staticClass: "dialog__backdrop" }),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "wrapper",
              staticClass: "dialog__wrapper",
              on: { click: _vm.closeFromWrapper },
            },
            [
              _c("div", { staticClass: "dialog__window" }, [
                _c("div", { staticClass: "dialog__content" }, [
                  _c("h2", {
                    staticClass: "dialog__title",
                    domProps: { innerHTML: _vm._s(_vm.dialogTitle) },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "dialog__message",
                    domProps: { innerHTML: _vm._s(_vm.dialogMessage) },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "dialog__buttons" },
                    [
                      _vm.dialogCancel
                        ? _c("Button", {
                            attrs: {
                              type: "button",
                              level: "secondary",
                              text: _vm.dialogCancel,
                              variants: ["small"],
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.onCancel.apply(null, arguments)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dialogConfirm
                        ? _c("Button", {
                            attrs: {
                              type: "button",
                              level: "primary",
                              text: _vm.dialogConfirm,
                              variants: ["small"],
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.onConfirm.apply(null, arguments)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }